import React from 'react';
import  { CellProps } from '../../stores/card/ModeExcel';
import { observer } from 'mobx-react';

interface ExcelTableCellLinkProps{
    cell:CellProps
}

@observer
export default class ExcelTableCellLink extends React.Component<ExcelTableCellLinkProps, any> {
    render() {
        const { cell } = this.props;
        const fieldtype = cell.fieldtype;
        const field = cell.field;
        const text = cell.evalue;
        let url = "";
        url = fieldtype == '1' ? "http://" : url;
        url = fieldtype == '2' ? "https://" : url;
        url = fieldtype == '3' ? "ftp://" : url;
        url = fieldtype == '4' ? "news://" : url;
        url += field;
        return (
            <a target="_blank" href={url}>{text}</a>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/CellLink.tsx